(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everblog-gift-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'eb-gift-showcase-v2';
  if (customElements.get(tag)) return;

  class EBGift extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;

        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.records = new Map();
        this.galleries = new Map();
        this.key = 'main';
        this.category = 'main';

        this.lastAccessory =
          this.querySelector('[data-eb-accessory]')?.dataset.ebAccessory;

        this.config = JSON.parse(
          this.querySelector('[data-eb-config]').textContent
        );

        this.querySelectorAll('[data-eb-panel]').forEach(panel => {
          const json = panel.querySelector('[data-eb-json]');
          if (!json) return;

          const data = JSON.parse(json.textContent);
          const select = panel.querySelector('[data-eb-variant]');
          const record = {
            panel,
            data,
            select,
            id: String(data.selected)
          };

          this.records.set(panel.dataset.ebPanel, record);
          this.applyVariant(record);
        });

        this.querySelectorAll('[data-eb-gallery]').forEach(el => {
          const viewport = el.querySelector('[data-eb-viewport]');
          if (!viewport) return;

          const gallery = {
            el,
            viewport,
            slides: [...el.querySelectorAll('[data-eb-slide]')],
            thumbs: [...el.querySelectorAll('[data-eb-thumb]')],
            index: 0
          };

          this.galleries.set(el.dataset.ebGallery, gallery);

          viewport.addEventListener('scroll', () => {
            cancelAnimationFrame(gallery.frame);

            gallery.frame = requestAnimationFrame(() => {
              if (!viewport.clientWidth) return;

              const index = Math.round(
                viewport.scrollLeft / viewport.clientWidth
              );

              this.paintGallery(gallery, index);
            });
          }, { passive: true, signal: this.signal });

          viewport.addEventListener('keydown', event => {
            if (
              event.key !== 'ArrowLeft' &&
              event.key !== 'ArrowRight'
            ) return;

            event.preventDefault();

            this.goImage(
              gallery,
              gallery.index + (event.key === 'ArrowRight' ? 1 : -1)
            );
          }, { signal: this.signal });

          const record = this.records.get(el.dataset.ebGallery);
          const imageId = record && this.variant(record)?.image;

          const initial = el.dataset.custom === 'true'
            ? 0
            : gallery.slides.findIndex(slide =>
                String(slide.dataset.imageId) === String(imageId)
              );

          this.paintGallery(gallery, Math.max(0, initial));
        });

        this.addEventListener(
          'click',
          event => this.click(event),
          { signal: this.signal }
        );

        this.addEventListener('change', event => {
          if (!event.target.matches('[data-eb-variant]')) return;

          const panel = event.target.closest('[data-eb-panel]');
          const record = this.records.get(panel.dataset.ebPanel);

          if (!record) return;

          record.id = event.target.value;
          this.applyVariant(record, true);
        }, { signal: this.signal });

        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[role="tab"]');

          if (
            !tab ||
            !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
          ) return;

          const tabs = [
            ...tab.closest('[role="tablist"]')
              .querySelectorAll('[role="tab"]:not(:disabled)')
          ];

          if (!tabs.length) return;

          let index = tabs.indexOf(tab);

          if (event.key === 'Home') {
            index = 0;
          } else if (event.key === 'End') {
            index = tabs.length - 1;
          } else {
            index = (
              index +
              (event.key === 'ArrowRight' ? 1 : -1) +
              tabs.length
            ) % tabs.length;
          }

          event.preventDefault();
          tabs[index].focus({ preventScroll: true });
          tabs[index].click();
        }, { signal: this.signal });

        document.addEventListener('shopify:block:select', event => {
          if (
            String(event.detail?.sectionId) !== this.dataset.sectionId
          ) return;

          const key = String(event.detail.blockId);

          if (this.records.has(key)) {
            this.activate('accessories', key);
          }
        }, { signal: this.signal });

        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          this.constructor.pending = false;
          this.setBusy(false);
        }, { signal: this.signal });

        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width === this.lastWidth) return;

          this.lastWidth = width;
          this.positionTabs();

          const gallery = this.galleries.get(this.key);

          if (gallery) {
            this.goImage(gallery, gallery.index, false);
          }
        });

        this.observer.observe(this);
        this.activate('main');

        document.fonts?.ready.then(() => {
          if (this.isConnected) this.positionTabs();
        });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();

      this.galleries?.forEach(gallery => {
        cancelAnimationFrame(gallery.frame);
      });
    }

    click(event) {
      const button = event.target.closest('button');

      if (
        !button ||
        !this.contains(button) ||
        button.disabled
      ) return;

      if (button.hasAttribute('data-eb-category')) {
        this.activate(button.dataset.ebCategory);

      } else if (button.hasAttribute('data-eb-accessory')) {
        this.activate('accessories', button.dataset.ebAccessory);

      } else if (button.hasAttribute('data-eb-thumb')) {
        const key = button.closest('[data-eb-gallery]').dataset.ebGallery;
        const gallery = this.galleries.get(key);

        this.goImage(gallery, Number(button.dataset.ebThumb));

      } else if (button.hasAttribute('data-eb-step')) {
        const key = button.closest('[data-eb-gallery]').dataset.ebGallery;
        const gallery = this.galleries.get(key);

        this.goImage(
          gallery,
          gallery.index + Number(button.dataset.ebStep)
        );

      } else if (button.hasAttribute('data-eb-action')) {
        this.purchase(button);
      }
    }

    activate(category, accessory) {
      if (category === 'accessories' && !this.lastAccessory) return;

      this.category = category;

      if (accessory) this.lastAccessory = accessory;

      this.key = category === 'main'
        ? 'main'
        : this.lastAccessory;

      this.querySelectorAll('[data-eb-category]').forEach(button => {
        const active = button.dataset.ebCategory === category;

        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });

      this.querySelectorAll('[data-eb-accessory]').forEach(button => {
        const active =
          button.dataset.ebAccessory === this.lastAccessory;

        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });

      this.querySelector('[data-eb-accessory-tabs]').hidden =
        category !== 'accessories';

      this.querySelectorAll(
        '[data-eb-gallery], [data-eb-panel]'
      ).forEach(el => {
        const active =
          (el.dataset.ebGallery || el.dataset.ebPanel) === this.key;

        el.hidden = !active;

        if (
          active &&
          !this.reduced &&
          typeof el.animate === 'function'
        ) {
          el.getAnimations().forEach(animation => animation.cancel());

          el.animate(
            [{ opacity: 0.4 }, { opacity: 1 }],
            { duration: 220, easing: 'ease-out' }
          );
        }
      });

      requestAnimationFrame(() => {
        if (!this.isConnected) return;

        this.positionTabs();

        const gallery = this.galleries.get(this.key);

        if (gallery) {
          this.goImage(gallery, gallery.index, false);
        }
      });
    }

    positionTabs() {
      this.querySelectorAll('[data-eb-tabs]').forEach(tabs => {
        if (!tabs.getClientRects().length) return;

        const selected = tabs.querySelector('[aria-selected="true"]');
        const indicator = tabs.querySelector('[data-eb-indicator]');

        if (!selected || !indicator) return;

        indicator.style.width = selected.offsetWidth + 'px';
        indicator.style.transform =
          'translateX(' + selected.offsetLeft + 'px)';

        const left = selected.offsetLeft;

        if (
          left < tabs.scrollLeft ||
          left + selected.offsetWidth >
            tabs.scrollLeft + tabs.clientWidth
        ) {
          tabs.scrollTo({
            left: Math.max(
              0,
              left - (tabs.clientWidth - selected.offsetWidth) / 2
            ),
            behavior: this.reduced ? 'auto' : 'smooth'
          });
        }
      });
    }

    paintGallery(gallery, index) {
      index = Math.max(
        0,
        Math.min(index, gallery.slides.length - 1)
      );

      gallery.index = index;

      const ratio = this.dataset.ratio === 'natural'
        ? Number(gallery.slides[index]?.dataset.ratio) || 1
        : Number(this.dataset.ratio) || 1;

      gallery.viewport.style.aspectRatio = String(ratio);

      gallery.thumbs.forEach((thumb, i) => {
        thumb.setAttribute('aria-current', String(i === index));
      });

      const count = gallery.el.querySelector('[data-eb-count]');

      if (count) {
        count.textContent =
          (index + 1) + ' / ' + gallery.slides.length;
      }

      gallery.el.querySelectorAll('[data-eb-step]').forEach(button => {
        button.disabled = Number(button.dataset.ebStep) < 0
          ? index === 0
          : index === gallery.slides.length - 1;
      });
    }

    goImage(gallery, index, smooth = true) {
      if (!gallery) return;

      this.paintGallery(gallery, index);

      gallery.viewport.scrollTo({
        left: gallery.index * gallery.viewport.clientWidth,
        behavior: smooth && !this.reduced ? 'smooth' : 'auto'
      });
    }

    variant(record) {
      return record.data.variants.find(variant =>
        String(variant.id) === String(record.id)
      );
    }

    applyVariant(record, updateImage = false) {
      const variant = this.variant(record);

      if (record.select) record.select.value = record.id;

      const price = record.panel.querySelector('[data-eb-price]');
      const compare = record.panel.querySelector('[data-eb-compare]');

      if (price) {
        price.textContent = variant?.priceText || '';
      }

      if (compare) {
        compare.hidden =
          !variant || !(variant.compare > variant.price);

        compare.textContent = variant?.compareText || '';
      }

      this.updateButtons(record);

      if (updateImage && variant?.image) {
        const gallery = this.galleries.get(
          record.panel.dataset.ebPanel
        );

        const index = gallery?.slides.findIndex(slide =>
          String(slide.dataset.imageId) === String(variant.image)
        );

        if (index >= 0) {
          this.goImage(gallery, index);
        }
      }
    }

    updateButtons(record) {
      const available = !!this.variant(record)?.available;

      record.panel.querySelectorAll('[data-eb-action]').forEach(button => {
        button.disabled = !!this.busy || !available;

        if (button.dataset.ebAction === 'buy') {
          button.querySelector('[data-eb-label]').textContent =
            available
              ? (
                  record.data.productPageOnly
                    ? 'Choose options'
                    : this.config.buy
                )
              : this.config.soldOut;
        }
      });

      if (record.select) {
        record.select.disabled = !!this.busy;
      }
    }

    setBusy(busy, button) {
      this.busy = busy;

      this.records.forEach(record => this.updateButtons(record));

      this.querySelectorAll('[data-eb-action]').forEach(el => {
        el.setAttribute(
          'aria-busy',
          String(busy && el === button)
        );
      });
    }

    async purchase(button) {
      if (this.busy || this.constructor.pending) return;

      const panel = button.closest('[data-eb-panel]');
      const record = this.records.get(panel.dataset.ebPanel);
      const variant = record && this.variant(record);

      if (!variant?.available) return;

      if (
        record.data.productPageOnly ||
        (
          button.dataset.ebAction === 'buy' &&
          this.config.buyAction === 'product'
        )
      ) {
        const url = new URL(record.data.url, location.origin);
        url.searchParams.set('variant', variant.id);
        location.assign(url.href);
        return;
      }

      this.constructor.pending = true;
      this.setBusy(true, button);

      const status = panel.querySelector('[data-eb-status]');
      const cartLink = panel.querySelector('[data-eb-cart-link]');

      status.textContent = '';
      status.removeAttribute('data-error');
      cartLink.hidden = true;

      let added = false;
      let navigating = false;

      const root = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variant.id,
              quantity: 1
            }]
          })
        });

        let data;

        try {
          data = await response.json();
        } catch (_) {
          throw new Error(
            'Please check your cart before trying again.'
          );
        }

        if (!response.ok || data.status >= 400) {
          throw new Error(
            typeof data.description === 'string'
              ? data.description
              : typeof data.message === 'string'
                ? data.message
                : 'Unable to add this option. Please check your cart.'
          );
        }

        added = true;
        status.textContent = this.config.added;
        cartLink.hidden = false;

        if (button.dataset.ebAction === 'buy') {
          location.assign(root + 'checkout');
          navigating = true;
          return;
        }

        const opened = await this.refreshAndOpenCart();

        button.dataset.success = 'true';

        setTimeout(() => {
          delete button.dataset.success;
        }, 1300);

        if (!opened) {
          status.textContent =
            this.config.added + ' You can view your cart below.';
        }

      } catch (error) {
        status.textContent = added
          ? this.config.added + ' Please open your cart to continue.'
          : (
              error instanceof TypeError
                ? 'Connection interrupted. Please check your cart before trying again.'
                : error.message
            );

        if (!added) status.dataset.error = 'true';

        cartLink.hidden = false;

      } finally {
        if (!navigating) {
          this.constructor.pending = false;
          this.setBusy(false);
        }
      }
    }

    async refreshAndOpenCart() {
      const getDrawer = () => document.querySelector('cart-drawer');
      const original = getDrawer();

      if (!original) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        return false;
      }

      const html = original.innerHTML;
      const target =
        original.closest('.shopify-section') ||
        original.parentElement;

      const updated = await new Promise(resolve => {
        let done = false;

        const finish = value => {
          if (done) return;

          done = true;
          observer.disconnect();
          clearTimeout(timer);
          resolve(value);
        };

        const observer = new MutationObserver(() => {
          const current = getDrawer();

          if (
            current &&
            (
              current !== original ||
              current.innerHTML !== html
            )
          ) {
            finish(true);
          }
        });

        const timer = setTimeout(() => finish(false), 5000);

        observer.observe(target, {
          childList: true,
          subtree: true,
          characterData: true
        });

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      });

      if (!updated || !this.isConnected) return false;

      await new Promise(resolve => requestAnimationFrame(resolve));

      const drawer = getDrawer();

      if (!drawer || typeof drawer.show !== 'function') {
        return false;
      }

      await drawer.show();
      return true;
    }
  }

  EBGift.pending = false;
  customElements.define(tag, EBGift);
})();

  } catch(e) { console.error(e); }
})();
})();
